export default __webpack_public_path__ + "static/media/hitanshu_monga.1a981fc3.jpeg";